import axiosClient from '../axiosClient';
import { BayEndpoints } from '../endpoints/bay';
import { BayResponse } from '../../types/api/response/bayresponse';
import { CreateBayRequest, UpdateBayRequest } from '../../types/api/request/bayrequest';

export const BayService = {
  async listBays(collectionPointId: number, activeOnly?: boolean): Promise<BayResponse[]> {
    const res = await axiosClient.get<BayResponse[]>(BayEndpoints.LIST, {
      params: { collection_point_id: collectionPointId, active_only: activeOnly ?? false },
    });
    return res.data;
  },

  async getBay(id: number): Promise<BayResponse> {
    const url = BayEndpoints.GET.replace(':id', id.toString());
    const res = await axiosClient.get<BayResponse>(url);
    return res.data;
  },

  async createBay(body: CreateBayRequest): Promise<BayResponse> {
    const res = await axiosClient.post<BayResponse>(BayEndpoints.CREATE, body);
    return res.data;
  },

  async updateBay(id: number, body: UpdateBayRequest): Promise<BayResponse> {
    const url = BayEndpoints.UPDATE.replace(':id', id.toString());
    const res = await axiosClient.put<BayResponse>(url, body);
    return res.data;
  },
};
